// extracted by mini-css-extract-plugin
module.exports = {"dragPreview":"DelayProfileDragPreview-dragPreview-SasSC"};